/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;padding:30px}header[_ngcontent-%COMP%]{display:flex;align-items:center}@media only screen and (max-width:768px){header[_ngcontent-%COMP%]{display:block;margin-bottom:25px}}.right-column[_ngcontent-%COMP%]{margin-left:auto}h1[_ngcontent-%COMP%]{margin:0 0 20px;font-weight:400}loading-indicator[_ngcontent-%COMP%]{margin:30px 0}.no-results-message[_ngcontent-%COMP%]{margin-top:50px}"];
export { styles as styles };
